/**
 * Tracks structure entities being deleted so debounced unmount-flush saves
 * do not race and re-write (or error on) rows that were intentionally removed.
 */
const pendingDeletes = new Set<string>();

export function beginStructureDelete(entityId: string): void {
  pendingDeletes.add(entityId);
}

export function endStructureDelete(entityId: string): void {
  pendingDeletes.delete(entityId);
}

export function isStructureDeletePending(entityId: string): boolean {
  return pendingDeletes.has(entityId);
}

/** Clear the guard shortly after React unmounts the deleted row. */
export function endStructureDeleteSoon(entityId: string, delayMs = 2000): void {
  window.setTimeout(() => endStructureDelete(entityId), delayMs);
}
